var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("validation-observer", {
        ref: "observer",
        attrs: { tag: "form" },
        on: {
          submit: function($event) {
            $event.preventDefault()
            return _vm.validateBeforeSubmit($event)
          }
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(props) {
              return [
                _c("validation-provider", {
                  staticClass: "position_relative",
                  attrs: { tag: "div", rules: "required", name: "password0" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function(ref) {
                          var errors = ref.errors
                          return [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.formdata.password0,
                                  expression: "formdata.password0"
                                }
                              ],
                              staticClass:
                                "form form--input form--placeholder_common margin_bottom_lg",
                              attrs: {
                                placeholder: _vm._("Enter Old Password"),
                                type: "password",
                                name: "password0",
                                required: "required"
                              },
                              domProps: { value: _vm.formdata.password0 },
                              on: {
                                keyup: function($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.validateBeforeSubmit($event)
                                },
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.formdata,
                                    "password0",
                                    $event.target.value
                                  )
                                }
                              }
                            }),
                            _c(
                              "span",
                              { staticClass: "error-text error-text--login" },
                              [_vm._v(_vm._s(errors[0]))]
                            )
                          ]
                        }
                      }
                    ],
                    null,
                    true
                  )
                }),
                _c("validation-provider", {
                  staticClass: "position_relative",
                  attrs: { tag: "div", rules: "required", name: "password1" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function(ref) {
                          var errors = ref.errors
                          return [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.formdata.password1,
                                  expression: "formdata.password1"
                                }
                              ],
                              staticClass:
                                "form form--input form--placeholder_common margin_bottom_lg",
                              attrs: {
                                placeholder: _vm._("Enter New Password"),
                                type: "password",
                                name: "password1",
                                required: "required"
                              },
                              domProps: { value: _vm.formdata.password1 },
                              on: {
                                keyup: function($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.validateBeforeSubmit($event)
                                },
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.formdata,
                                    "password1",
                                    $event.target.value
                                  )
                                }
                              }
                            }),
                            _c(
                              "span",
                              { staticClass: "error-text error-text--login" },
                              [_vm._v(_vm._s(errors[0]))]
                            )
                          ]
                        }
                      }
                    ],
                    null,
                    true
                  )
                }),
                _c("validation-provider", {
                  staticClass: "position_relative",
                  attrs: { tag: "div", rules: "required", name: "password2" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function(ref) {
                          var errors = ref.errors
                          return [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.formdata.password2,
                                  expression: "formdata.password2"
                                }
                              ],
                              staticClass:
                                "form form--input form--placeholder_common margin_bottom_lg",
                              attrs: {
                                placeholder: _vm._("Repeat New Password"),
                                type: "password",
                                name: "password2",
                                required: "required"
                              },
                              domProps: { value: _vm.formdata.password2 },
                              on: {
                                keyup: function($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.validateBeforeSubmit($event)
                                },
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.formdata,
                                    "password2",
                                    $event.target.value
                                  )
                                }
                              }
                            }),
                            _c(
                              "span",
                              { staticClass: "error-text error-text--login" },
                              [_vm._v(_vm._s(errors[0]))]
                            )
                          ]
                        }
                      }
                    ],
                    null,
                    true
                  )
                }),
                _c(
                  "button",
                  {
                    staticClass:
                      "button button--color_blue button--width_full button--submit fs_2md",
                    attrs: { disabled: _vm.isLoad, type: "submit" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.validateBeforeSubmit($event)
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm._("Change Password")))]
                ),
                _vm.errorText.length > 0
                  ? _c(
                      "div",
                      { staticClass: "position_relative margin_top_lg" },
                      [
                        _c(
                          "span",
                          { staticClass: "error-text error-text--login" },
                          [_vm._v(_vm._s(_vm.errorText))]
                        )
                      ]
                    )
                  : _vm._e()
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-401b6892", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-401b6892","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/Forms/ChangePassword.vue
// module id = 536
// module chunks = 0